<template>
  <modal
    ref="sendDownstream"
    @closed="destroySetup"
    @exited="destroySetup"
    :title="modalTitle"
    :width="2500"
    closeButton
  >
    <v-tabs
      v-model="tab"
      color="primary"
      slider-color="primary"
      centered
      v-bind:class="{ 'activation-modal__hide-tabs': !this.activatingAudience }"
    >
      <v-tab
        v-for="tab in tabs"
        :key="tab.name"
      >
        {{ tab.name }}
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item>
        <div class="activation-modal__name-container__videoamp">
          <div class="activation-modal__name-section__videoamp">
            <v-text-field
              name="audienceName"
              label="Audience Name"
              id="activationModalAudienceName"
              v-model="value.display_name"
              readonly
              hide-details="true"
              dense
              filled
            ></v-text-field>
          </div>
        </div>
        <div class="activation-modal__bottom-container">
          <v-row
            justify="space-between"
            class="pa-0 pl-3 pr-3"
          >
            <v-col
              md="5"
              class="pl-0 pr-2"
            >
              <campaign-quarter-select
                :initialValue="videoampMetadata.campaign_quarter"
                @updatedCampaignQuarter="val => (videoampMetadata.campaign_quarter = val)"
              >
              </campaign-quarter-select>
            </v-col>
            <v-col
              md="5"
              class="pl-0 pr-2"
            >
              <v-text-field
                dense
                hide-details="auto"
                label="Advertiser"
                v-model="videoampMetadata.advertiser"
              ></v-text-field>
            </v-col>
            <v-col
              md="5"
              class="pl-0 pr-2"
            >
              <v-text-field
                dense
                hide-details="auto"
                label="Videoamp ID"
                v-model="videoampMetadata.videoamp_id"
              ></v-text-field>
            </v-col>
            <v-col
              md="5"
              class="pl-0 pr-2"
            >
              <v-text-field
                dense
                readonly
                hide-details="auto"
                label="Currency"
                v-model="videoampMetadata.currency"
              ></v-text-field>
            </v-col>
            <v-col
              md="5"
              class="pl-0 pr-2"
            >
              <v-text-field
                dense
                hide-details="auto"
                label="Deal #"
                v-model="videoampMetadata.deal_number"
              ></v-text-field>
            </v-col>
            <v-col
              md="5"
              class="pl-0 pr-2"
            >
              <demo-id
                :initialValue="videoampMetadata.demo_id"
                @updatedDemoId="val => (videoampMetadata.demo_id = val)"
              >
              </demo-id>
            </v-col>
          </v-row>
        </div>
      </v-tab-item>
      <v-tab-item>
        <div class="activation-modal__name-container">
          <div class="activation-modal__name-section">
            <v-text-field
              name="audienceName"
              label="Audience Name"
              id="activationModalAudienceName"
              v-model="value.display_name"
              readonly
              hide-details="true"
              dense
              filled
            ></v-text-field>
          </div>
          <div class="activation-modal__options-area__advertiser pad">
            <div class="activation-modal__select-area">
              <advertiser-select
                @update="val => (value.advertiser = val)"
                :initialValue="value.advertiser"
                :showAdvertiserId="true"
                :disabled="disableAdvertiser"
                :filled="true"
              />
            </div>
          </div>
          <div
            v-if="showViewingStream"
            class="activation-modal__options-area__streaming pad"
          >
            <div class="activation-modal__select-area">
              <streaming-select
                @input="val => (value.viewing_stream = val)"
                :initialValue="value.viewing_stream"
                :viewingOption="viewingOption"
                :disabled="disableViewingStream"
              />
            </div>
          </div>
        </div>
        <div class="activation-modal__bottom-container">
          <div class="activation-modal__endpoints-area">
            <div
              class="activation-modal__destinations"
              v-for="destination in destinations"
              :key="destination.id"
            >
              <MVPD
                :destination="destination"
                :selected="value.destinations.includes(destination.id)"
                :canUpdate="canUpdateUE()"
                :UE="0"
                :MRM_ID="mrmID()"
                @selectedDestination="selectDestination(destination)"
                @UEChanged="ue => updateCanoeUE(ue)"
                @MRMIDChanged="mrmId => updateMrmID(mrmId)"
              />
            </div>
          </div>
          <div
            v-if="!foresiteDestinationSelected"
            class="activation-modal__campaign-area"
          >
            <div
              v-if="isDigitalSocialDestination"
              class="activation-modal__options-area activation-modal__full-width"
            >
              <!-- <div v-if="isLoading" class="xandr-create-target__loading">
                <loading-dots></loading-dots>
              </div> -->
              <!-- <div v-show="!isLoading" class="activation-modal__select-area"> -->
              <div class="activation-modal__select-area">
                <div class="activation-modal__select-label">Campaign</div>
                <campaign-d-d-l
                  v-model="selectedCampaignId"
                  :optionSet="filteredCampaigns"
                />
              </div>
              <div
                v-if="isDigitalSocialDestination || isUpdatingAfterSubmitted"
                class="xandr-create-target__date-area"
              >
                <flight-dates
                  ref="flightDates"
                  :value="{
                    flightStartDate: value.am_data.flightStartDate,
                    flightEndDate: value.am_data.flightEndDate,
                  }"
                  @input="val => modifyDates(val)"
                  :disabled="disableFlightDates || disableFlightDatesValue"
                  :startIsInFuture="startIsInFuture"
                  :endIsInFuture="endIsInFuture"
                  :endIsWithin45Days="endIsWithin45Days"
                  :attStatus="originalAttStatus"
                  :submittionDate="submittedTimestamp"
                  :isSubmitted="isSubmitted"
                  :isLive="isLive"
                  :isWorking="isWorking"
                  :isActivatedStatus="isActivatedStatus"
                  :originalFlightEndDate="originalEndDate"
                />
              </div>
              <div class="activation-modal__select-area">
                <div class="activation-modal__select-label">Day</div>
                <day-of-week-d-d-l
                  v-model="exportDayOfWeek"
                  :disabled="updateCampaignEditable ? false : true"
                />
              </div>
            </div>
            <v-row
              v-if="showFrequency"
              style="margin: 0px"
            >
              <!-- <div v-if="showFrequency" class="activation-modal__select-area"> -->
              <frequency-d-d-l
                @input="val => (value.xandr_data.frequency = val)"
                :initialValue="value.xandr_data ? value.xandr_data.frequency : null"
                :optionSet="frequencyOptionSet"
                :disabled="disableFrequency"
              />
              <!-- </div> -->
            </v-row>
          </div>
          <div
            v-if="foresiteDestinationSelected"
            class="activation-modal__broadcast-quarter-area"
          >
            <broadcast-quarter-select @input="val => (broadcastQuarter = val)" />
            <demo-qualifier @demoQualifier="val => (demoQualifier = val)" />
          </div>
        </div>
      </v-tab-item>
    </v-tabs-items>
    <div
      class="activation-modal__button-area"
      slot="actions"
    >
      <div
        v-if="showAdvertiserRequiredMessage"
        class="activation-modal__advertiser-required"
      >
        Advertiser is required in order to send downstream
      </div>
      <action-button
        v-if="!activatingAudience && !disableSendDownstream"
        dark
        :disabled="disableSendDownstream"
        @click.native="submitDownstream"
        label="Send Downstream"
        color="primary"
        id="sendDownstreamModalBtn"
      />
      <action-button
        v-if="activatingAudience"
        dark
        :disabled="disableActivate"
        @click.native="activateAudience"
        label="Activate"
        color="primary"
        id="activateAudienceModalBtn"
      />
    </div>
  </modal>
</template>

<script>
  import Modal from '@/components/common/modal'
  import ActionButton from '@/components/common/actionButton'
  import TargetName from '@/appComponents/targets/createTarget/components/TargetName'
  import AdvertiserSelect from '@/appComponents/targets/components/AdvertiserSelect'
  import StreamingSelect from '@/appComponents/targets/components/StreamingSelect'
  import MVPD from '@/appComponents/targets/createTarget/components/MVPD.vue'
  import CampaignDDL from '@/appComponents/targets/components/CampaignDDL'
  import DayOfWeekDDL from '@/appComponents/targets/components/DayOfWeekDDL'
  import FlightDates from '@/appComponents/targets/createTarget/components/FlightDates'
  import FrequencyDDL from '@/appComponents/targets/components/FrequencyDDL'
  import BroadcastQuarterSelect from '@/appComponents/targets/components/BroadcastQuarterSelect'
  import DemoQualifier from '@/appComponents/targets/components/DemoQualifier'
  import CampaignQuarterSelect from '@/appComponents/targets/createTarget/components/CampaignQuarterSelect'
  import DemoId from '@/appComponents/targets/createTarget/components/DemoId'
  import LoadingDots from '@/components/common/loaderDots'
  import { convertViewingStreamForAM } from '@/appLogic/targets/conversions'

  import { cloneDeep } from 'lodash'
  import {
    DESTINATIONS,
    DESTINATION_OBJECTS,
    FREQUENCY_OPTION_SET,
    DATASOURCES,
    TARGET_TYPE,
    TARGET_TYPES_INTEGERS,
    FREQUENCIES,
    INTENTS,
    VIEWING_STREAMS,
    MARKETPLACE_ENDPOINTS,
    TARGET_ACTIONS,
    ACTIVATION_STATUS,
  } from '@/appLogic/targets/Constants'
  import {
    SUBMIT_DOWNSTREAM,
    SET_ENABLE_DOWN_STREAM,
    SET_TARGET,
    SAVE_TARGET,
  } from '@/appLogic/workbench/common/store/actions'
  import XandrApi from '@/api/XandrAPI'
  import { POST_TARGET, SET_REFRESH_TABLE_FLAG } from '@/views/audienceHub/store/actions'
  import {
    SET_UPDATING_TARGET,
    RESET_THE_LAS_MODAL,
    CREATE_TARGET_NO_ACTUALS,
  } from '@/appLogic/targets/createTarget/store/actions'
  //   import { PERMISSIONS_OLD } from '@/appLogic/permissions/Constants.js'
  import { validationMixin } from 'vuelidate'
  import { required, minLength } from 'vuelidate/lib/validators'

  const TAB_NAME = {
    VIDEOAMP: 'VIDEOAMP',
    ADDRESSABLE: 'ADDRESSABLE',
  }

  export default {
    mixins: [validationMixin],
    components: {
      Modal,
      ActionButton,
      TargetName,
      AdvertiserSelect,
      StreamingSelect,
      MVPD,
      CampaignDDL,
      DayOfWeekDDL,
      FlightDates,
      FrequencyDDL,
      BroadcastQuarterSelect,
      DemoQualifier,
      CampaignQuarterSelect,
      DemoId,
      LoadingDots,
    },
    props: {
      value: {
        default: () => {
          return {
            display_name: '',
            destinations: [],
            xandr_data: {
              frequency: FREQUENCIES.MONTHLY,
            },
            viewing_stream: null,
            am_data: {
              flightStartDate: null,
              flightEndDate: null,
              status: null,
              xdFlightOverlap: 0,
            },
          }
        },
        display_name: {
          type: String,
          required: true,
          default: '',
        },
        destinations: {
          type: Array,
          required: true,
          default: [],
        },
        advertiser: {
          type: Object,
          required: true,
          default: null,
        },
        viewing_stream: {
          type: String,
          required: true,
          default: null,
        },
        xandr_data: {
          frequency: {
            type: Number,
            default: null,
          },
        },
      },
    },
    data() {
      return {
        next: null,
        modalTitle: 'Activation Window',
        targetNameDisabled: true,
        disableViewingStream: true,
        disableAdvertiser: true,
        destinations: [],
        MVPDs: [],
        frequencyOptionSet: this.selectedAdstraDatasetFamily ? FREQUENCY_OPTION_SET.MONTHLY : 0,
        selectedCampaignId: null,
        destinationIds: [],
        selectedDestinationIds: [],
        filteredCampaigns: [],
        creatingAddressableAudience: this.selectedAdstraDatasetFamily || false, // this value will be defaulted to false when adding Krux, LiveRamp and Symphony destinations
        creatingDigitalAudience:
          this.selectedPrismDatasetFamily ||
          this.selectedDNBDatasetFamily ||
          this.selectedMaxDatasetFamily ||
          this.selectedTVEDatasetFamily ||
          this.selectedEpsilonDatasetFamily ||
          this.selectedDiscoveryPlusDatasetFamily ||
          this.selectedDCRDatasetFamily ||
          false, // this value will be defaulted to false when adding addressable destinations
        mvpdsReceived: false,
        campaignsReceived: false,
        destinationIdsReceived: false,
        isLoading: true,
        buttonClicked: false,
        addressableDestinations: [
          DESTINATIONS.DIRECTV,
          DESTINATIONS.VIZIO,
          DESTINATIONS.CANOE_LINEAR,
          DESTINATIONS.CANOE_VOD,
        ],
        broadcastQuarter: null,
        demoQualifier: null,
        foresiteDestinationSelected: false,
        digitalDestinations: [DESTINATIONS.FREEWHEEL, DESTINATIONS.GOOGLE_AD_MANAGER],
        LAS_DESTINATIONS: [DESTINATIONS.SYMPHONY, DESTINATIONS.FORESITE],
        tab: 0,
        tabs: [{ name: TAB_NAME.VIDEOAMP }, { name: TAB_NAME.ADDRESSABLE }],
        videoampMetadata: {
          campaign_quarter: null,
          advertiser: null,
          videoamp_id: null,
          currency: 'VideoAmp',
          deal_number: null,
          demo_id: null,
        },
        isVideoampMetadataUpdated: false,
      }
    },
    validations: {
      value: {
        display_name: { required },
        advertiser: {
          Name: this.isDigitalSocialDestination ? null : { required },
        },
        viewing_stream: { required },
        destinations: { required, minLength: minLength(1) },
      },
    },
    created() {
      this.getMVPDS().then(() => {
        if (this.activatingAudience) {
          this.value.xandr_data = { frequency: null }
        }
        this.setFrequencyOption()
        this.setDestinations()
        this.setXandrExternal()
      })
    },
    mounted() {
      let that = this
      this.getMVPDS()
        .then(() => {
          if (this.activatingAudience) {
            this.value.xandr_data = { frequency: null }
          }
          this.setFrequencyOption()
        })
        .then(function () {
          if (that.$store.getters.hasAdSalesSocialDigitalPermissions) {
            XandrApi.getDestinationsConfig()
              .then(res => {
                that.destinationIdsReceived = true
                that.destinationIds = { ...res, Foresite: '99' } // placeholder value for Foresite
              })
              .then(function () {
                if (
                  that.availableDestinations.some(destination =>
                    [DESTINATIONS.KRUX, DESTINATIONS.LIVERAMP].includes(destination),
                  )
                ) {
                  XandrApi.getCampaigns(null, true).then(resp => {
                    that.campaignsReceived = true
                    that.campaigns = resp
                  })
                }
              })
          } else console.log('no permissions')
        })
        .finally(function () {
          that.isLoading = false
        })
    },
    computed: {
      activatingAudience() {
        return this.$store.state.createTarget.initialTargetAction === TARGET_ACTIONS.ACTIVATE
      },
      isDigitalSocialDestination() {
        return (
          this.value.destinations &&
          this.value.destinations.some(destination => [DESTINATIONS.KRUX, DESTINATIONS.LIVERAMP].includes(destination))
        )
      },
      showAdvertiserRequiredMessage() {
        if (!this.value.destinations || this.value.destinations.length === 0) return false
        return (
          !this.isDigitalSocialDestination &&
          !(this.value.advertiser && this.value.advertiser.Name) &&
          !this.isDigitalDestination
        )
      },
      disableFrequency() {
        // return (!this.isDuplicating && !this.isUpdatableBeforeSubmittion) || (this.isDigitalSocialDestination && !this.isNewCampaignCreated) || (this.hasAddressableDestination && this.value.activation_status === ACTIVATION_STATUS.CANCELLED)
        return false
      },
      showViewingStream() {
        return (
          this.isLASDestination ||
          this.foresiteDestinationSelected ||
          (!this.activatingAudience && !this.creatingDigitalAudience && !this.selectedDNBDatasetFamily) ||
          (this.activatingAudience && this.isAddressableTab)
        )
      },
      showFrequency() {
        return this.creatingAddressableAudience
      },
      selectedLasDatasetFamily() {
        let df = this.selectedDatasetFamily
        return df === 'amrld' || df === 'mri' || df === 'ncs'
      },
      selectedDatasetFamily() {
        return this.$store.getters['workbench/selectedFamilyDataset']
      },
      noSelectedDatasetFamily() {
        return !this.selectedDatasetFamily
      },
      selectedAdstraDatasetFamily() {
        return this.selectedDatasetFamily === TARGET_TYPE.ADSTRA || this.selectedDatasetFamily === 'xandr'
      },
      selectedPrismDatasetFamily() {
        return this.selectedDatasetFamily === DATASOURCES.PRISM
      },
      selectedMaxDatasetFamily() {
        return this.selectedDatasetFamily === DATASOURCES.MAX
      },
      selectedTVEDatasetFamily() {
        return this.selectedDatasetFamily === DATASOURCES.TVE
      },
      selectedDNBDatasetFamily() {
        return this.selectedDatasetFamily === DATASOURCES.DNB
      },
      selectedEpsilonDatasetFamily() {
        return this.selectedDatasetFamily === DATASOURCES.EPSILON
      },
      selectedDiscoveryPlusDatasetFamily() {
        return this.selectedDatasetFamily === DATASOURCES.DISCOVERY_PLUS
      },
      selectedDCRDatasetFamily() {
        return this.selectedDatasetFamily === DATASOURCES.DCR
      },
      newWorkbenchTarget() {
        return this.$store.getters['workbench/newWorkbenchTarget']
      },
      disableSendDownstream() {
        return (
          (!this.isDigitalDestination && this.$v.$invalid) ||
          this.buttonClicked ||
          !this.$store.getters.hasPublishPermissions
        )
      },
      disableActivate() {
        return (
          !this.$store.getters.hasPublishPermissions ||
          this.buttonClicked ||
          (this.isAddressableTab && this.selectedDestinationIds.length < 1) ||
          (this.isVideoampTab && !this.isVideoampMetadataUpdated)
        )
      },
      availableDestinations() {
        return this.$store.getters['workbench/availableDestinations']
      },
      viewingOption() {
        return this.selectedAdstraDatasetFamily || this.creatingAddressableAudience ? 6 : 5
      },
      isAddressableDestination() {
        return this.value.destinations && this.addressableDestinations.some(a => this.value.destinations.includes(a))
      },
      isDigitalDestination() {
        return this.value.destinations && this.digitalDestinations.some(a => this.value.destinations.includes(a))
      },
      isLASDestination() {
        return this.value.destinations && this.LAS_DESTINATIONS.some(a => this.value.destinations.includes(a))
      },
      isEveryVideoampMetadataUpdated() {
        const videoampMetaDataKeys = [
          'demo_id',
          'deal_number',
          'videoamp_id',
          'advertiser',
          'currency',
          'campaign_quarter',
        ]
        return videoampMetaDataKeys.every(
          key =>
            this.videoampMetadata.hasOwnProperty(key) &&
            this.videoampMetadata[key] !== null &&
            this.videoampMetadata[key] !== '',
        )
      },
      isVideoampTab() {
        return this.tabs[this.tab].name === TAB_NAME.VIDEOAMP
      },
      isAddressableTab() {
        return this.tabs[this.tab].name === TAB_NAME.ADDRESSABLE
      },
    },
    methods: {
      open() {
        this.buttonClicked = false
        if (this.selectedLasDatasetFamily) {
          if (this.value.destinations.length === 0) {
            this.value.destinations = [DESTINATIONS.SYMPHONY]
          }
          this.value.viewing_stream = convertViewingStreamForAM(this.$store.getters['workbench/viewingStream'])
        }
        this.setFrequencyOption()
        this.setDestinations()
        if (this.destinations.length === 1) {
          this.selectDestination(this.destinations[0])
        }
        if (!this.activatingAudience) {
          this.tab = 1
        }
        this.getMVPDS().then(() => {
          this.$refs.sendDownstream.open()
        })
      },
      close() {
        this.$refs.sendDownstream.close()
        if (this.activatingAudience) {
          this.$store.dispatch(SET_UPDATING_TARGET, null)
        }
      },
      getMVPDS() {
        return new Promise(resolve => {
          this.MVPDs = this.$store.state.createTarget.mvpds
          this.mvpdsReceived = true
          resolve()
        })
      },
      setDestinations(newVal = this.value.destinations || []) {
        if (this.selectedLasDatasetFamily && this.value.destinations && this.value.destinations.length === 0) {
          this.value.destinations = [DESTINATIONS.SYMPHONY]
          return
        }

        // Deprecated by AM-3571. As permissions are restructured with AM-3571, checking destination permissions are removed
        // const newDestinations = newVal.filter((destination) => {
        //   switch (destination) {
        //     case DESTINATIONS.KRUX:
        //       return this.$store.state.auth.permissions.includes(PERMISSIONS_OLD.AD_SALES_XANDR_KRUX)
        //     case DESTINATIONS.LIVERAMP:
        //       return this.$store.state.auth.permissions.includes(PERMISSIONS_OLD.AD_SALES_XANDR_LIVE_RAMP)
        //     case DESTINATIONS.CANOE_LINEAR:
        //       return this.$store.state.auth.permissions.includes(PERMISSIONS_OLD.AD_SALES_XANDR_CANOE_LINEAR) || this.$store.state.auth.permissions.includes(PERMISSIONS_OLD.AD_SALES_ADSTRA_CANOE_LINEAR)
        //     case DESTINATIONS.CANOE_VOD:
        //       return this.$store.state.auth.permissions.includes(PERMISSIONS_OLD.AD_SALES_XANDR_CANOE_VOD) || this.$store.state.auth.permissions.includes(PERMISSIONS_OLD.AD_SALES_CANOE_VOD)
        //     default:
        //       return true
        //   }
        // })
        // const hasPermissions = newDestinations.length === newVal.length

        // if (!hasPermissions) {
        //   this.value.destinations = newDestinations.length ? newDestinations : []
        // }

        if (this.value.destinations.includes(DESTINATIONS.FORESITE)) {
          this.foresiteDestinationSelected = true
        } else {
          this.foresiteDestinationSelected = false
        }

        this.destinations = DESTINATION_OBJECTS.filter(d => {
          if (this.availableDestinations.includes(d.id)) {
            return d.id
          }
        })
      },
      setFrequencyOption() {
        if (this.creatingAddressableAudience) {
          this.frequencyOptionSet = FREQUENCY_OPTION_SET.ADSTRA
          this.$set(this.value.xandr_data, 'frequency', FREQUENCIES.MONTHLY)
          delete this.value.xandr_data.exportDayOfWeek
        } else if (this.creatingDigitalAudience) {
          this.frequencyOptionSet = FREQUENCY_OPTION_SET.DIGITAL
          this.$set(this.value.xandr_data, 'frequency', FREQUENCIES.WEEKLY)
          this.value.xandr_data.exportDayOfWeek = 0
        }
      },
      setXandrExternal() {
        if (!this.activatingAudience && (this.noSelectedDatasetFamily || this.selectedLasDatasetFamily)) return

        this.value.xandr_data.external = undefined
        this.value.xandr_data.addressable = undefined
        if (this.MVPDs && this.MVPDs.length) {
          // Addressable
          if (this.creatingAddressableAudience) {
            this.setFrequencyOption()
            this.value.xandr_data.external = []
            this.value.xandr_data.addressable = true
            if (this.activatingAudience) {
              this.value.target = TARGET_TYPE.ADSTRA
              this.value.target_datasource = DATASOURCES.ADSTRA
              this.value.target_type = TARGET_TYPES_INTEGERS.ADSTRA
              this.value.am_data = { flightStartDate: null, flightEndDate: null, status: null, xdFlightOverlap: 0 }
            }
            // Canoe Linear
            if (this.value.destinations.includes(DESTINATIONS.CANOE_LINEAR)) {
              const canoe_mvpd = this.MVPDs.find(mvpd => mvpd.Name === MARKETPLACE_ENDPOINTS.CANOE_LINEAR)
              this.value.xandr_data.external.push({
                endpointID: canoe_mvpd.Id,
                endpointName: canoe_mvpd.Name,
                externalID: '',
                universeEstimates: null,
              })

              if (this.value.viewing_stream !== VIEWING_STREAMS.LSD) {
                this.value.viewing_stream = VIEWING_STREAMS.LSD
              }
            }

            // Canoe VOD
            if (this.value.destinations.includes(DESTINATIONS.CANOE_VOD)) {
              const canoe_vod_mvpd = this.MVPDs.find(mvpd => mvpd.Name === MARKETPLACE_ENDPOINTS.CANOE_VOD)
              this.value.xandr_data.external.push({
                endpointID: canoe_vod_mvpd.Id,
                endpointName: canoe_vod_mvpd.Name,
                externalID: '',
                universeEstimates: null,
              })

              if (this.value.viewing_stream !== VIEWING_STREAMS.LSD) {
                this.value.viewing_stream = VIEWING_STREAMS.LSD
              }
            }

            // Vizio
            if (this.value.destinations.includes(DESTINATIONS.VIZIO)) {
              const vizio_mvpd = this.MVPDs.find(mvpd => mvpd.Name === MARKETPLACE_ENDPOINTS.VIZIO)
              this.value.xandr_data.external.push({
                endpointID: vizio_mvpd.Id,
                endpointName: vizio_mvpd.Name,
                externalID: '',
                universeEstimates: null,
              })

              this.value.am_data.xdFlightOverlap = 0

              if (this.value.viewing_stream !== VIEWING_STREAMS.LSD) {
                this.value.viewing_stream = VIEWING_STREAMS.LSD
              }
              // this.$emit('isDigital', false)
            }

            // DirecTV
            if (this.value.destinations.includes(DESTINATIONS.DIRECTV)) {
              const atttv_mvpd = this.MVPDs.find(mvpd => mvpd.Name === MARKETPLACE_ENDPOINTS.DIRECTV)
              this.value.xandr_data.external.push({
                endpointID: atttv_mvpd.Id,
                endpointName: atttv_mvpd.Name,
                externalID: '',
                universeEstimates: null,
              })

              if (this.value.viewing_stream !== VIEWING_STREAMS.LSD) {
                this.value.viewing_stream = VIEWING_STREAMS.LSD
              }
              // this.$emit('isDigital', false)
            }
            // Non-Addressable
          } else {
            this.value.xandr_data.addressable = false
            if (
              this.value.destinations.find(destination =>
                [DESTINATIONS.KRUX, DESTINATIONS.LIVERAMP].includes(destination),
              )
            ) {
              this.value.am_data.xdFlightOverlap = 0
              this.frequencyOptionSet = FREQUENCY_OPTION_SET.XANDR_SOCIAL_DIGITAL
              this.$set(this.value.xandr_data, 'frequency', FREQUENCIES.WEEKLY)
              // this.$emit('isDigital', true)
            } else if (
              this.value.destinations.find(destination =>
                [DESTINATIONS.FREEWHEEL, DESTINATIONS.GOOGLE_AD_MANAGER].includes(destination),
              )
            ) {
              this.setFrequencyOption()
              if (this.activatingAudience) {
                this.value.target = TARGET_TYPE.PRISM
                this.value.target_datasource = DATASOURCES.PRISM
                this.value.target_type = TARGET_TYPES_INTEGERS.PRISM
                this.value.am_data = { flightStartDate: null, flightEndDate: null, status: null, xdFlightOverlap: 0 }
              }
            } else if (
              this.value.destinations.find(destination =>
                [DESTINATIONS.SYMPHONY, DESTINATIONS.FORESITE].includes(destination),
              )
            ) {
              if (this.value.xandr_data.frequency === FREQUENCIES.WEEKLY) {
                this.$set(this.value.xandr_data, 'frequency', null)
              }
              this.frequencyOptionSet = process.env.ENABLE_FREQUENCIES ? FREQUENCY_OPTION_SET.LINEAR : 0
              if (this.activatingAudience) {
                this.value.target = TARGET_TYPE.LAS
                this.value.target_datasource = DATASOURCES.MRI
                this.value.target_type = TARGET_TYPES_INTEGERS.LAS
              }
              // this.$emit('isDigital', false)
            }
          }
        }
      },
      selectDestination(destination) {
        const targetDestinations = new Set(this.value.destinations)
        if (destination.isDisabled || (this.isActivated && !this.isDuplicating)) return
        const isDestinationAlreadySelected = targetDestinations.has(destination.id)
        const isAddressableDestinationFound = this.addressableDestinations.some(a => targetDestinations.has(a))
        const isDigitalDestinationFound = this.digitalDestinations.some(a => targetDestinations.has(a))
        // this line was basically for preventing the deselection of Symphony, so now we'll just make that explicit
        if (destination.id === DESTINATIONS.SYMPHONY && isDestinationAlreadySelected) {
          return
        }
        if (isDestinationAlreadySelected) targetDestinations.delete(destination.id)
        else targetDestinations.add(destination.id)

        let that = this
        const clearSelectedDestinations = function () {
          that.value.destinations = []
          targetDestinations.clear()
        }

        switch (destination.id) {
          case DESTINATIONS.FORESITE:
            if (isAddressableDestinationFound || isDigitalDestinationFound) {
              clearSelectedDestinations()
              targetDestinations.add(destination.id)
            }
            targetDestinations.add(DESTINATIONS.SYMPHONY)
            if (!isDestinationAlreadySelected) {
              this.value.viewing_stream = VIEWING_STREAMS.C3
              this.selectedCampaignId = null
              this.creatingAddressableAudience = false
            }
            break
          case DESTINATIONS.SYMPHONY: {
            if (isAddressableDestinationFound || isDigitalDestinationFound) {
              clearSelectedDestinations()
              targetDestinations.add(destination.id)
            }
            if (!isDestinationAlreadySelected) {
              this.value.viewing_stream = VIEWING_STREAMS.C3
              this.selectedCampaignId = null
              this.creatingAddressableAudience = false
              this.creatingDigitalAudience = false
            }
            break
          }
          case DESTINATIONS.KRUX: {
            if (isAddressableDestinationFound) {
              clearSelectedDestinations()
              targetDestinations.add(destination.id)
            }
            if (!isDestinationAlreadySelected) {
              const isLiverampDestinationFound = targetDestinations.has(DESTINATIONS.LIVERAMP)
              if (isLiverampDestinationFound) targetDestinations.add(DESTINATIONS.KRUX)
              this.creatingAddressableAudience = false
              this.creatingDigitalAudience = false
            }
            break
          }
          case DESTINATIONS.LIVERAMP: {
            if (isAddressableDestinationFound) {
              clearSelectedDestinations()
              targetDestinations.add(destination.id)
            }
            if (!isDestinationAlreadySelected) {
              const hasKruxDest = this.value.destinations.includes(DESTINATIONS.KRUX)
              if (hasKruxDest) targetDestinations.add(DESTINATIONS.LIVERAMP)
              this.creatingAddressableAudience = false
              this.creatingDigitalAudience = false
            }
            break
          }
          case DESTINATIONS.DIRECTV: {
            if (!isDestinationAlreadySelected) {
              if (isAddressableDestinationFound) targetDestinations.add(DESTINATIONS.DIRECTV)
              if (!isAddressableDestinationFound) {
                clearSelectedDestinations()
                targetDestinations.add(DESTINATIONS.DIRECTV)
              }
              this.selectedCampaignId = null
              this.creatingAddressableAudience = true
              this.creatingDigitalAudience = false
            }
            break
          }
          // JAKE TODO something here about the XDFlightDates
          case DESTINATIONS.VIZIO: {
            if (!isDestinationAlreadySelected) {
              if (isAddressableDestinationFound) targetDestinations.add(DESTINATIONS.VIZIO)
              if (!isAddressableDestinationFound) {
                clearSelectedDestinations()
                targetDestinations.add(DESTINATIONS.VIZIO)
              }
              this.selectedCampaignId = null
              this.creatingAddressableAudience = true
              this.creatingDigitalAudience = false
            }
            break
          }
          case DESTINATIONS.CANOE_LINEAR: {
            if (!isDestinationAlreadySelected) {
              if (isAddressableDestinationFound) targetDestinations.add(DESTINATIONS.CANOE_LINEAR)
              if (!isAddressableDestinationFound) {
                clearSelectedDestinations()
                targetDestinations.add(DESTINATIONS.CANOE_LINEAR)
              }
              this.selectedCampaignId = null
              this.creatingAddressableAudience = true
              this.creatingDigitalAudience = false
            }
            break
          }
          case DESTINATIONS.CANOE_VOD: {
            if (!isDestinationAlreadySelected) {
              if (isAddressableDestinationFound) targetDestinations.add(DESTINATIONS.CANOE_VOD)
              if (!isAddressableDestinationFound) {
                clearSelectedDestinations()
                targetDestinations.add(DESTINATIONS.CANOE_VOD)
              }
              this.selectedCampaignId = null
              this.creatingAddressableAudience = true
              this.creatingDigitalAudience = false
            }
            break
          }
          case DESTINATIONS.FREEWHEEL: {
            if (!isDestinationAlreadySelected) {
              if (isDigitalDestinationFound) targetDestinations.add(DESTINATIONS.FREEWHEEL)
              if (!isDigitalDestinationFound) {
                clearSelectedDestinations()
                targetDestinations.add(DESTINATIONS.FREEWHEEL)
              }
              this.selectedCampaignId = null
              this.creatingDigitalAudience = true
              this.creatingAddressableAudience = false
            }
            break
          }
          case DESTINATIONS.GOOGLE_AD_MANAGER: {
            if (!isDestinationAlreadySelected) {
              if (isDigitalDestinationFound) targetDestinations.add(DESTINATIONS.GOOGLE_AD_MANAGER)
              if (!isDigitalDestinationFound) {
                clearSelectedDestinations()
                targetDestinations.add(DESTINATIONS.GOOGLE_AD_MANAGER)
              }
              this.selectedCampaignId = null
              this.creatingDigitalAudience = true
              this.creatingAddressableAudience = false
            }
            break
          }
        }
        if (this.creatingAddressableAudience) {
          this.value.viewing_stream = VIEWING_STREAMS.LSD
        }
        if (this.creatingDigitalAudience) {
          this.value.xandr_data.exportDayOfWeek = 0
        }
        this.value.destinations = Array.from(targetDestinations)

        this.setDestinations()
        this.setXandrExternal()
        this.selectedDestinationIds = this.value.destinations.map(id => this.destinationIds[id])
      },
      submitDownstream() {
        this.buttonClicked = true
        if (this.foresiteDestinationSelected) {
          this.value.target_definition = { ...this.value.target_definition, broadcastQuarter: this.broadcastQuarter }
          this.value.metadata.foresite = { demoQualifier: this.demoQualifier }
        } else {
          delete this.value.target_definition.broadcastQuarter
          if (this.value.metadata.foresite) delete this.value.metadata.foresite
        }
        this.$store
          .dispatch('workbench/' + SAVE_TARGET, { target: cloneDeep(this.value), ignoreSavePrompt: true })
          .then(resp => {
            if (this.isAddressableDestination || this.isDigitalDestination) {
              this.$store.dispatch('workbench/' + SUBMIT_DOWNSTREAM)
            } else {
              let copiedTarget = cloneDeep(this.newWorkbenchTarget)
              this.$store.dispatch('workbench/' + SET_ENABLE_DOWN_STREAM, false)
              this.$store.dispatch(POST_TARGET, copiedTarget).then(resp => {
                this.$store.dispatch('workbench/' + SET_TARGET, copiedTarget)
                this.$router.push({ name: 'NewWorkbench', params: { id: this.value.id } })
              })
            }
            this.close()
          })
      },
      activateAudience() {
        this.buttonClicked = true
        this.value.activation_status = ACTIVATION_STATUS.ACTIVATED
        this.value.username = this.$store.state.auth.username
        if (this.foresiteDestinationSelected && this.isAddressableTab) {
          this.value.target_definition = { ...this.value.target_definition, broadcastQuarter: this.broadcastQuarter }
          this.value.metadata.foresite = { demoQualifier: this.demoQualifier }
        } else {
          delete this.value.target_definition.broadcastQuarter
          if (this.value.metadata.foresite) delete this.value.metadata.foresite
        }
        if (this.isVideoampTab) {
          this.value.activation_status = ACTIVATION_STATUS.LIVE
          this.value.target = TARGET_TYPE.VIDEOAMP
          this.value.target_datasource = DATASOURCES.VIDEOAMP
          this.value.target_type = TARGET_TYPES_INTEGERS.VIDEOAMP
          this.value.viewing_stream = VIEWING_STREAMS.C3
          this.value.metadata.videoamp = { ...this.videoampMetadata }
          if (this.value.xandr_data) delete this.value.xandr_data
          if (this.value.advertiser && this.value.advertiser.Name) {
            this.value.advertiser = { Name: null }
          }
        }
        this.$store.dispatch(SET_REFRESH_TABLE_FLAG, false)
        this.$store.dispatch(CREATE_TARGET_NO_ACTUALS, this.value).then(resp => {
          this.$store.dispatch(RESET_THE_LAS_MODAL)
          this.$refs.sendDownstream.close()
          this.$store.dispatch(SET_REFRESH_TABLE_FLAG, true)
        })
      },
      destroySetup() {
        this.$refs.sendDownstream.close()
        if (
          this.value.activation_status === ACTIVATION_STATUS.DRAFT ||
          this.value.activation_status === ACTIVATION_STATUS.WORKING
        ) {
          this.value.destinations = []
          this.creatingDigitalAudience = false
          this.creatingAddressableAudience = false
          // if (this.value.xandr_data) {
          //   delete this.value.xandr_data.frequency
          //   delete this.value.xandr_data.exportDayOfWeek
          // }
        }
        if (this.activatingAudience) {
          this.value.destinations = []
          this.creatingDigitalAudience = false
          this.creatingAddressableAudience = false
          this.videoampMetadata = {
            campaign_quarter: null,
            advertiser: null,
            videoamp_id: null,
            currency: 'VideoAmp',
            deal_number: null,
            demo_id: null,
          }
          if (this.value.xandr_data) {
            delete this.value.xandr_data.frequency
            delete this.value.xandr_data.exportDayOfWeek
          }
          this.$store.dispatch(RESET_THE_LAS_MODAL)
        }
      },
      updateCanoeUE(ue) {
        // TODO
      },
      updateMrmID(mrmId) {
        // TODO
      },
      canUpdateUE() {
        return false
      },
      mrmID() {
        // TODO
        return 'todo'
      },
    },
    watch: {
      isEveryVideoampMetadataUpdated(value) {
        this.isVideoampMetadataUpdated = value
      },
      tab(value) {},
    },
  }
</script>

<style lang="scss">
  .mover-1 {
    animation: moveSlideshow 5s linear infinite;
  }

  @keyframes moveSlideshow {
    100% {
      transform: translateX(-66.6666%);
    }
  }

  .activation-modal {
    &__name-container {
      display: flex;
      justify-content: start;
      padding: 20px;

      &__videoamp {
        display: flex;
        justify-content: center;
        padding: 20px;
      }
    }

    &__select-label {
      text-align: center;
    }

    &__bottom-container {
      display: flex;
      padding: 20px;
    }

    &__name-section {
      text-align: center;
      display: inline-block;
      width: 28%;
      margin: 0 2.67%;

      &__videoamp {
        text-align: center;
        display: inline-block;
        width: 40%;
        margin: 0 2.67%;
      }

      &__label {
        display: block;
      }

      &__input {
        // display: block;
        // text-align: left;
        // border: 1px solid rgba(60, 60, 60, 0.26) !important;
        // border-radius: 0 !important;
        // line-height: 1.42857143;
        // margin: 4px 2px 0;
        // padding: 0.3em 0.25em;
        // color: #333;

        // margin: 0 auto;
        // position: relative;
        // overflow: hidden;
        // transform: translate3d(0, 0, 0);

        // color: #333;
        // background-color: #f8f8f8;
        max-width: 600px;
        margin: 0 auto;
        position: relative;
        overflow: hidden;
        transform: translate3d(0, 0, 0);
        border: 1px solid rgba(60, 60, 60, 0.26);
        line-height: 1.42857143;
        padding: 0.3em 0.25em;
      }

      &__input > td {
        // height: 200px;
        width: 256px;
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        transform: translate3d(0, 0, 0);
      }
    }

    &__hide-tabs {
      display: none;
    }

    &__options-area {
      text-align: center;
      display: inline-block;
      width: 25%;
      // margin-left: 25%;
      // &.pad {
      //   margin-bottom: 15px;
      //   margin-top: 15px;
      // }

      &__advertiser {
        width: 28%;
        margin: 0 2.67%;
      }

      &__streaming {
        width: 28%;
        margin: 0 2.67%;
      }
    }

    &__button-area {
      margin: auto;
      min-height: 36px;
      // &>button {
      //   margin-bottom: 4px;
      // }
    }

    &__select-area {
      flex: 1;
      // & + div {
      //   margin-left: 15px;
      // }
    }

    &__endpoints-area {
      width: 60%;
      padding: 20px;
      display: flex;
      flex-wrap: wrap;
    }

    &__campaign-area {
      width: 40%;
      padding: 20px;
    }

    &__broadcast-quarter-area {
      width: 40%;
      padding: 30px;
    }

    &__full-width {
      width: 100%;
    }

    &__destinations {
      display: inline-block;
      margin-top: 15px;
    }

    &__advertiser-required {
      text-align: center;
      font-weight: bold;
      margin-bottom: 12px;
    }
  }
</style>



// WEBPACK FOOTER //
// SendDownstream.vue?99a3725a